import { addApiPrefix } from 'as-ui-kit/utils/urls';
import { getFetchOptions, handleResult } from 'as-ui-kit/utils/http';
import { catchWithMsg } from 'utils/http';
import { snakeToPascalObj } from 'as-ui-kit/utils/adapters';

export const getAllFeatures = (apiUrl) =>
    fetch(addApiPrefix('/webapi/enabler/v1.0/features', apiUrl))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);

export const viewFeature = (featureId, apiUrl) =>
    fetch(addApiPrefix(`/webapi/enabler/v1.0/features/${featureId}/view`, apiUrl), getFetchOptions('', 'POST'))
        .then(handleResult)
        .catch(catchWithMsg);